import {metadaApi} from '@dms/api/base';

import {
  DeleteTransferOrderRequest,
  DeleteTransferOrderRequestSchema,
  DeleteTransferOrderResponse,
  DeleteTransferOrderResponseSchema,
  GetTransferOrderRequest,
  GetTransferOrderRequestSchema,
  GetTransferOrderResponse,
  GetTransferOrderResponseSchema,
  PatchTransferOrderRequest,
  PatchTransferOrderRequestSchema,
  PatchTransferOrderResponse,
  PatchTransferOrderResponseSchema,
  PostTransferOrderRequest,
  PostTransferOrderRequestSchema,
  PostTransferOrderResponse,
  PostTransferOrderResponseSchema,
} from './types';

export const metadaWarehouseTransferOrderApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getTransferOrder: build.query<GetTransferOrderResponse, GetTransferOrderRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'transferOrders', id: queryArg.transferOrderId},
      ],
      extraOptions: {
        requestSchema: GetTransferOrderRequestSchema,
        responseSchema: GetTransferOrderResponseSchema,
      },
    }),
    postTransferOrder: build.mutation<PostTransferOrderResponse, PostTransferOrderRequest>({
      query: (queryArg) => ({
        url: 'warehouse/v1/transfer-order',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: (result, _error, _queryArg) => [
        {type: 'transferOrders', id: result?.transferOrderId},
      ],
      extraOptions: {
        requestSchema: PostTransferOrderRequestSchema,
        responseSchema: PostTransferOrderResponseSchema,
      },
    }),
    patchTransferOrder: build.mutation<PatchTransferOrderResponse, PatchTransferOrderRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrders', id: queryArg.transferOrderId},
      ],
      extraOptions: {
        requestSchema: PatchTransferOrderRequestSchema,
        responseSchema: PatchTransferOrderResponseSchema,
      },
    }),
    deleteTransferOrder: build.mutation<DeleteTransferOrderResponse, DeleteTransferOrderRequest>({
      query: (queryArg) => ({
        url: 'warehouse/v1/transfer-order/delete',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['transferOrders'],
      extraOptions: {
        requestSchema: DeleteTransferOrderRequestSchema,
        responseSchema: DeleteTransferOrderResponseSchema,
      },
    }),
  }),
});

export const {
  useGetTransferOrderQuery,
  usePostTransferOrderMutation,
  usePatchTransferOrderMutation,
  useDeleteTransferOrderMutation,
} = metadaWarehouseTransferOrderApi;
